import { Issue, PermittedAction } from "@adsk/acc-issues-types";
import { useMemo } from "react";

export const useHasPermissionToRestoreIssues = (issues: Issue[]) => {
  return useMemo(
    () =>
      issues.every(i => i.permittedActions.includes(PermittedAction.Restore)),
    [issues]
  );
};

export const useHasPermissionToRestoreIssue = (issue: Issue) => {
  return useHasPermissionToRestoreIssues([issue]);
};
